import React from "react";
import { AuthContext } from "./AuthContext.js";

export const useAuth = () => React.useContext(AuthContext);
